export default __webpack_public_path__ + "static/_/_/legos/assets/lib/valorant/icon/abilities/ability-vyse-e.webp";